import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "../APIClient";
import { GetRateableParticipantsResponseDto } from "../generated/generatedTypes";

const fetchRateableParticipants = async (
  eventId: number
): Promise<GetRateableParticipantsResponseDto> => {
  const response = await apiFetch(`api/user-rating/event/${eventId}/participants`);
  if (!response.ok) {
    throw new Error("평가할 참석자 목록을 불러오지 못했습니다.");
  }
  return response.json();
};

export const useGetRateableParticipants = (eventId: number | null, enabled = true) => {
  return useQuery({
    queryKey: ["rateableParticipants", eventId],
    queryFn: () => fetchRateableParticipants(eventId!),
    enabled: !!eventId && enabled,
  });
};
